module.exports = __webpack_public_path__ + "img/pr-8.1bb51766.png";